'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export function useScrollToTopOnLoad() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
}
function _temp() {
  const {
    history,
    performance
  } = globalThis;
  const [navigation] = (performance?.getEntriesByType?.("navigation") ?? []) as PerformanceNavigationTiming[];
  if (navigation?.type !== "reload") {
    return;
  }
  const previous = history?.scrollRestoration;
  if (history) {
    history.scrollRestoration = "manual";
  }
  globalThis.scrollTo(0, 0);
  return () => {
    if (history && previous) {
      history.scrollRestoration = previous;
    }
  };
}